/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {addPrivacyRequestTag} from '../api'

export const useMutationAddPrivacyRequestTag = createReactQueryMutationHook('addPrivacyRequestTag', addPrivacyRequestTag)
